import TYPES from '@/types';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { Router } from '@/modules/shared/domain/router';

export default class UpdateIneConfirmationModalViewModel {
  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.ROUTER)
  private readonly router!: Router;

  readonly i18n_namespace = 'components.user-profile.user-profile-tabs.user-profile-my-documents-tab.update-ine.confirmation';

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  goToUpdateInePage = () => {
    this.router.navigate('/update-identity-document-authenticated');
  }
}
